import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult } from 'react-query';
import { ErrorMessage, ActivationState, UidAndToken } from 'types';
import { client } from 'utils/api-client';

export default function useActivationState(): UseMutationResult<
  AxiosResponse<ActivationState>,
  AxiosError<ErrorMessage>,
  UidAndToken
> {
  return useMutation(request => client.post('/auth/activation-state/', request));
}
